import { taxRateUrl } from "../Config/Url";
import axios from "axios";

export const taxRateService = {
  get,
  getById,
  create,
  update,
  deleteTaxRate,
};

async function get({ searchName, pageIndex, pageSize }) {
  return axios
    .put(`${taxRateUrl}/search`, { searchName, pageIndex, pageSize })
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}

async function getById(taxRateId) {
  return axios
    .get(`${taxRateUrl}/${taxRateId}`)
    .then((res) => res)
    .catch((err) => err.response.data);
}

async function create({ name, value }) {
  return axios
    .post(taxRateUrl, {
      name,
      value,
    })
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}

async function update({ taxRateId, name, value }) {
  return axios
    .put(`${taxRateUrl}/${taxRateId}`, {
      name,
      value,
    })
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}

async function deleteTaxRate(taxRateId) {
  return axios
    .delete(`${taxRateUrl}/${taxRateId}`)
    .then((res) => res)
    .catch((err) => {
      throw new Error("Uneseni podaci nisu ispravni.");
    });
}
